import { RouteConfig } from 'react-router-config';
import GatewaysListPage from 'components/pages/GatewaysListPage';
import GatewayDetailPage from 'components/pages/GatewayDetailPage';
import { ROUTE_PATH_GATEWAY_DETAIL, ROUTE_PATH_GATEWAYS_LIST } from './config';

export const gatewaysRoutes: RouteConfig[] = [
  {
    path: ROUTE_PATH_GATEWAYS_LIST,
    exact: true,
    component: GatewaysListPage,
  },
  {
    path: ROUTE_PATH_GATEWAY_DETAIL,
    exact: true,
    component: GatewayDetailPage,
  },
];
